import TimeLine from "../components/real-time/TimeLine";
import {useEffect, useState} from "react";
import {
    getLastDataFromEachPoint,
    getNearestStation,
    getOrientationOfEach,
    translateStations
} from "../shared/translateStationIntoPositions";
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";
import {CircularProgress, ListItem, ListItemAvatar} from "@mui/material";
import {format, parseISO} from "date-fns";
import PulseDot from "../components/PulseDot";
import Layout from "../layouts";
import Loading from "../components/Loading";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import {dateToMexico} from "../shared/utils";

function RealTimePage() {

    const [orientation, setOrientation] = useState([]);
    const [units, setUnits] = useState([]);
    const [points, setPoints] = useState([]);
    const [stations,] = useState(translateStations());
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState('');

    const MINUTE_MS = 120000;

    /**
     * API Call to retrieve the last positions
     * @returns {Promise<{orientation: *[], data, nearestStation: *[]}|*[]>}
     */
    const getLastThreePoints = async () => {
        try {
            setLoading(true);
            const lastActivity = await fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + '/api/statuses/real-time/positions', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Content-Type': "application/json",
                    'X-Requested-With': 'XMLHttpRequest',
                }
            });

            let json = await lastActivity.json();
            if (json && json.data.length > 0) {
                setPoints(getLastDataFromEachPoint(json.data));
                setOrientation(getOrientationOfEach(json.data));
                setUnits(getNearestStation(json.data));
                setDate(new Date());
            }
            setLoading(false);
        } catch (e) {
            throw new Error(e);
        }
    }

    useEffect(() => {

        // Call Interval fn
        const interval = setInterval(() => {
            getLastThreePoints()
        }, MINUTE_MS);

        if (points && points.length === 0) {
            getLastThreePoints();
        }

        return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, [])


    const MapContainerWithNoSSR = dynamic(
        () => import("../components/MapRealTime"),
        {
            ssr: false,
            loading: () => (
                <Box sx={{display: 'flex'}}>
                    <CircularProgress/>
                </Box>
            )
        })

    /**
     * Blinking effect
     * @param dateISOFormat
     * @returns {JSX.Element}
     */
    const secondaryAction = (dateISOFormat) => {
        const date = dateToMexico(dateISOFormat, false);
        let isSameDay = false;
        const now = format(new Date(), "yyyy/MM/dd");

        if (date === now) {
            isSameDay = true;
        }

        return (
            <Box sx={{mr: "1em"}}>
                <PulseDot isOutDated={!isSameDay}/>
            </Box>
        )
    }

    return (

        <Layout>
            <Loading open={loading}></Loading>
            <Paper sx={{bgcolor: "white", p: 1, mt: 2, border: "1px solid #b0bec5", boxShadow: 0}}>
                <Typography variant={"subtitle2"} sx={{textTransform: "uppercase"}}>
                    Último llamado: &nbsp;
                    {date !== '' && (
                        <>
                            {format(date, 'yyyy/MM/dd HH:mm:ss')}
                        </>
                    )} (Periodo de actualización: 120 seg)
                </Typography>
            </Paper>
            <Paper sx={{display: "flex", p: 0, mt: 2, border: "1px solid #b0bec5"}}>
                <Paper sx={{m: 0, p: 0, width: "15%", height: "90vh", boxShadow: 0}}>
                    <Box sx={{height: "100%", borderRight: 1, borderColor: "#b0bec5"}}>
                        <Box sx={{borderBottom: 1, borderColor: "#b0bec5"}}>
                            <Typography variant={"subtitle2"}
                                        sx={{px: 2, py: 1, textTransform: "uppercase", height: "35px"}}>
                                Camiones en ruta
                            </Typography>
                        </Box>
                        <Box sx={{height: "calc(100% - 35px) !important", overflow: "auto"}}>
                            <List dense={false}>
                                {points && points.length > 0 && (
                                    <>
                                        {points.map((point, i) => (
                                            <ListItem key={i}
                                                      secondaryAction={secondaryAction(point.created_at)}>
                                                {/*<ListItemAvatar>*/}
                                                    {/*<Avatar sx={{bgcolor: "#8fa2ac"}}>*/}
                                                    {/*    <DepartureBoardIcon/>*/}
                                                    {/*</Avatar>*/}
                                                {/*</ListItemAvatar>*/}
                                                <ListItemText
                                                    primary={"ECO " + point.unit_number}
                                                    secondary={dateToMexico(point.created_at)}
                                                />
                                            </ListItem>
                                        ))}
                                    </>
                                )}
                            </List>
                        </Box>
                    </Box>
                </Paper>
                <Paper sx={{m: 0, p: 0, minWidth: "35%", maxWidth: "35%", height: "90vh", boxShadow: 0, overflow: "scroll", borderLeft: 1, borderColor: "#b0bec5"}}>
                        {stations && stations.length > 0 && units.length > 0 && orientation.length > 0 && (
                            <TimeLine stations={stations} units={units} orientation={orientation} points={points}></TimeLine>
                        )}
                </Paper>
                <Paper sx={{m: 0, p: 0, width: "50%", height: "90vh", boxShadow: 0}}>
                    <MapContainerWithNoSSR points={points}/>
                </Paper>
            </Paper>
        </Layout>
    )
}

export default RealTimePage